class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerTopWrapper = document.querySelector('[data-header-top-wrapper]');
    this.headerBottomWrapper = document.querySelector('[data-header-bottom-wrapper]');
    this.menuDrawer = document.querySelector('[data-menu-drawer]');
    this.toggleNavigation = document.querySelector('[data-toggle-navigation]');

    this.removeEventListener('mouseleave', this.reducer.mouseLeaveGroup);
    this.removeEventListener('mouseleave', this.reducer.mouseLeaveContainer);
    this.addEventListener('mouseleave', this.closeAll);

    this.collapsibleGroups = this.querySelectorAll('[data-collapsible-group]');
    this.nonCollapsible = this.querySelectorAll('.header__menu-item--level-1:not([data-collapsible-group])');

    this.collapsibleGroups.forEach((group) => {
      this.groupTrigger = group.querySelector('[data-collapsible-trigger]');

      this.groupTrigger.removeEventListener('mouseenter', this.reducer.mouseEnterTarget);

      group.removeEventListener('mouseleave', this.reducer.mouseLeaveGroup);
      group.removeEventListener('mouseleave', this.reducer.mouseLeaveContainer);

      this.groupTrigger.addEventListener('mouseenter', () => {
        this.closeAll();
        this.open(group);
      })
    });

    this.nonCollapsible.forEach((item) => item.addEventListener('mouseenter', () => this.closeAll()));

    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow.addEventListener('click', this.closeAll.bind(this));

      window.addEventListener('scroll', this.onScroll.bind(this), false);
      window.addEventListener('resize', () => {
        if (this.menuDrawer.classList.contains('menu-drawer--is-active') && window.innerWidth > 1024) {
          this.menuDrawer.querySelector('toggle-navigation').click();
          this.menuDrawer.classList.remove('menu-drawer--is-active');
        }
      });
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      this.header.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        this.header.classList.remove('header--is-open');
        this.inverse && this.header.classList.remove('header--inverse-solid');
      }
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const screenWidth = window.innerWidth;
    if (screenWidth > 1024) {
      if (scrollTop > 50) {
        this.headerTopWrapper.classList.add('header__top-wrapper--is-scrolled');
      }
      else {
        this.headerTopWrapper.classList.remove('header__top-wrapper--is-scrolled');
        this.headerBottomWrapper?.classList.remove('header__bottom--is-active');
        this.toggleNavigation.classList.remove('header__nav-toggle-button--is-toggled');
      }
    }
  }
}

class ToggleNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerBottomWrapper = document.querySelector('[data-header-bottom-wrapper]');
    this.mobileDrawer = document.querySelector('[data-menu-drawer]');
    this.headerShadow = document.querySelector('[data-header-shadow]');

    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // iPhone fix
      if (navigator.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this));
      this.shadow.addEventListener('click', this.remove.bind(this));
    }

    // remove the default eventListener on click
    this.removeEventListener('click', this.reducer.click);

    // if the device width is bigger than the header bp open the desktop nav menu, else open the menu drawer
    this.addEventListener('click', function() {
      if ( window.innerWidth > 1024) {
        this.headerBottomWrapper?.classList.toggle('header__bottom--is-active');
        this.classList.toggle('header__nav-toggle-button--is-toggled');
      } else {
        this.mobileDrawer.classList.toggle('menu-drawer--is-active');
        this.header.classList.toggle('header--is-open');
      }
    });
    this.headerShadow.addEventListener('click', function() {
      if ( window.innerWidth < 1024) {
        document.querySelector('[data-menu-drawer]').classList.remove('menu-drawer--is-active');
      }
    });
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header && this.screenWidth < 1024) {
      this.header.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
    }
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    if (this.header) {
      this.header.classList.remove('header--is-open');
      this.inverse && this.header.classList.remove('header--inverse-solid');
    }
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', this.onKeyUp.bind(this));


    // click outside search
    document.addEventListener("click", (e) => {
      // if search is open
      if (this.target?.classList.contains(toggleClass)) {
        const isOutside = !e.target.closest(target);
        if (isOutside) {
          this.remove();
        }
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.header = document.querySelector('#shopify-section-header');
    this.headerWrapper = document.querySelector('.header');
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.headerElement = this;
    this.headerInverse = !!this.headerElement.classList.contains('header--inverse');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');

    if (this.header) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        const announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;
      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // scroll event
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop <= this.headerStart) {
      requestAnimationFrame(this.revealTop.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
      requestAnimationFrame(this.reveal.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    if (this.headerInverse) {
      this.headerElement.classList.add('header--inverse-solid');
    }
  }

  revealTop() {
    if (this.headerInverse && !this.classList.contains('header--is-open')) {
      this.headerElement.classList.remove('header--inverse-solid');
    }
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if(!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-navigation')) {
  customElements.define('toggle-navigation', ToggleNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
